import { LocaleStartParams } from '@platform-frontend/transloco';
import { AccountNavigationExtras } from '../../account-router';
import { SignInMode } from './sign-in-mode';

export interface GotoSignInNavigationExtras<T extends LocaleStartParams = LocaleStartParams> extends AccountNavigationExtras<T> {
  signInMode?: SignInMode;
  onError?: string;
}
